import { Briefcase, Eye, Shield, UserCheck } from "lucide-react";

export const ROLES = {
	admin: {
		key: "admin",
		label: "Administrador",
		icon: Shield,
		color: "cyan",
		badgeClass: "bg-cyan-600/20 text-cyan-300 border-cyan-500/30",
		permissions: [
			"Ver tudo",
			"Criar/editar/deletar empresas",
			"Criar/editar/deletar planos e modulos",
			"Criar/editar/deletar clientes",
			"Criar/editar/deletar/enviar propostas",
			"Criar/editar/deletar templates",
			"Gerenciar usuarios e roles",
			"Alterar configuracoes do sistema",
			"Ver logs de atividade",
			"Gerenciar motivos de rejeicao",
		],
	},
	manager: {
		key: "manager",
		label: "Gerente",
		icon: Briefcase,
		color: "blue",
		badgeClass: "bg-blue-600/20 text-blue-300 border-blue-500/30",
		permissions: [
			"Ver tudo",
			"Criar/editar/deletar empresas",
			"Criar/editar/deletar planos e modulos",
			"Criar/editar/deletar clientes",
			"Criar/editar/deletar/enviar propostas",
			"Criar/editar/deletar templates",
			"Ver logs de atividade",
			"Gerenciar motivos de rejeicao",
		],
	},
	salesperson: {
		key: "salesperson",
		label: "Vendedor",
		icon: UserCheck,
		color: "green",
		badgeClass: "bg-green-600/20 text-green-300 border-green-500/30",
		permissions: [
			"Ver empresas, planos, modulos, clientes",
			"Criar clientes",
			"Criar/enviar/clonar propostas (somente as proprias)",
			"Ver templates",
		],
	},
	viewer: {
		key: "viewer",
		label: "Visualizador",
		icon: Eye,
		color: "slate",
		badgeClass: "bg-slate-600/20 text-slate-400 border-slate-500/30",
		permissions: [
			"Ver empresas, planos, modulos",
			"Ver clientes",
			"Ver propostas",
			"Ver templates",
		],
	},
};

export const ROLE_OPTIONS = Object.entries(ROLES).map(([value, r]) => ({
	value,
	label: r.label,
}));

// Permissions matrix for Settings page
export const PERMISSIONS_MATRIX = [
	{
		feature: "Dashboard",
		admin: true,
		manager: true,
		salesperson: true,
		viewer: true,
	},
	{
		feature: "Empresas (ver)",
		admin: true,
		manager: true,
		salesperson: true,
		viewer: true,
	},
	{
		feature: "Empresas (criar/editar/deletar)",
		admin: true,
		manager: true,
		salesperson: false,
		viewer: false,
	},
	{
		feature: "Planos (ver)",
		admin: true,
		manager: true,
		salesperson: true,
		viewer: true,
	},
	{
		feature: "Planos (criar/editar/deletar)",
		admin: true,
		manager: true,
		salesperson: false,
		viewer: false,
	},
	{
		feature: "Modulos (ver)",
		admin: true,
		manager: true,
		salesperson: true,
		viewer: true,
	},
	{
		feature: "Modulos (criar/editar/deletar)",
		admin: true,
		manager: true,
		salesperson: false,
		viewer: false,
	},
	{
		feature: "Clientes (ver)",
		admin: true,
		manager: true,
		salesperson: true,
		viewer: true,
	},
	{
		feature: "Clientes (criar)",
		admin: true,
		manager: true,
		salesperson: true,
		viewer: false,
	},
	{
		feature: "Clientes (editar/deletar)",
		admin: true,
		manager: true,
		salesperson: false,
		viewer: false,
	},
	{
		feature: "Propostas (ver)",
		admin: true,
		manager: true,
		salesperson: true,
		viewer: true,
	},
	{
		feature: "Propostas (criar/enviar)",
		admin: true,
		manager: true,
		salesperson: true,
		viewer: false,
	},
	{
		feature: "Propostas (editar/deletar)",
		admin: true,
		manager: true,
		salesperson: false,
		viewer: false,
	},
	{
		feature: "Templates",
		admin: true,
		manager: true,
		salesperson: true,
		viewer: true,
	},
	{
		feature: "Templates (criar/editar/deletar)",
		admin: true,
		manager: true,
		salesperson: false,
		viewer: false,
	},
	{
		feature: "Log de Atividades",
		admin: true,
		manager: true,
		salesperson: false,
		viewer: false,
	},
	{
		feature: "Usuarios",
		admin: true,
		manager: false,
		salesperson: false,
		viewer: false,
	},
	{
		feature: "Configuracoes",
		admin: true,
		manager: false,
		salesperson: false,
		viewer: false,
	},
	{
		feature: "Motivos de Rejeicao",
		admin: true,
		manager: true,
		salesperson: false,
		viewer: false,
	},
];
